import { useMutation as rqUseMutation, } from 'react-query';
export const useMutation = (mutationFn, options) => {
    return rqUseMutation(mutationFn, options);
};
//# sourceMappingURL=useMutation.js.map